import  swal  from 'sweetalert2';
import { Component, OnInit } from '@angular/core';
import { DireccionService } from 'app/services/direccion.service';
import { Titular, Grupo, Beneficiario } from 'app/entities/personajes';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { DireccionComponent } from '../../../modals/direccion/direccion.component';
import { GruposService } from '../../../services/grupos.service';

@Component({
    selector: 'app-direcciones',
    templateUrl: './direcciones.component.html',
    styleUrls: ['./direcciones.component.scss']
})
export class DireccionesComponent implements OnInit {

    constructor(private _geo:DireccionService,private _modal:MatDialog,private _grupo:GruposService) {
        this.currentPageTit = 1;
        this.currentPageBen = 1;
    }

    public spinner;

    public titulares:Array<Titular>;
    public benficiarios:Array<Beneficiario>;
    public grupo:Grupo;
    public radicado:string;
    public selectedTitular:string;
    public currentPageBen:number;
    public currentPageTit:number;
    ngOnInit() {
        this.spinner = true;
    }

    loadGroup():void{
        this.spinner = false;
        this.selectedTitular = "";
        this._geo.grupoBenTit(this.radicado)
                  .subscribe(response=>{
                      this.grupo = response.grupo;
                      this.titulares=response.titulares;
                      this.benficiarios = response.beneficiarios;
                      this.spinner = true;
                });
    }

    direccion(beneficiario:Beneficiario){
        console.log(beneficiario)
        let modal:MatDialogRef<DireccionComponent> = this._modal.open(DireccionComponent,{
            width: '60%',
            height: '79%',
            disableClose:true,
            data:{actual_direccion: beneficiario.direccion,key:beneficiario.documento,tipoDir:'beneficiario'}
        });

        modal.afterClosed().subscribe(data=>{
            if(!data) return;
            this._geo.saveDir(data,beneficiario.documento).subscribe(succ=>{
                swal.fire({
                    title:'Exito',
                    type:'success',
                    text:'Se guardó con exito la dirección',
                    showConfirmButton: false,
                    timer:1000
                })
            })
        })
    }

    setActive(id){
        console.log(id);
        this.selectedTitular = id;
    }

    reset(){
        this.radicado = '';
        this.grupo = {};
        this.titulares = [];
        this.benficiarios = [];
    }

    numeroContrato(inputValue){
        swal.fire({
            input:'text',
            title:'Número de contrato',
            text:'Ingrese el número del contrato',
            inputValue,
            showCancelButton:true,
            confirmButtonText:'Aceptar',
            cancelButtonText:'Cancelar'
        }).then(data=>{
            if(!data.dismiss) 
                this._grupo.setContratNumber(data.value,this.grupo.radicado).subscribe(succ=>{
                    swal.fire({
                        type:'success',
                        title:'Completado!',
                        text:'Se actualizó con exito',
                        showConfirmButton:false,
                        timer:1000
                });
                this.grupo.numeroContrato = data.value
            });
        })
    }
}
